import * as http from "./base";

const prefix = "/contacts";

export async function fetchContactsList({
  page,
  sort,
  search,
  page_size,
  queryString
}) {
  const qs = http.prepareQueryString({
    page,
    sort,
    search,
    page_size,
    queryString
  });

  return await http.get(`${prefix}-list/?${qs}`);
}

export async function fetchCsvHistory(
  page = 1,
  sorting,
  searchString = "",
  limit = 25
) {
  const reqPage = page ? `&page=${page}` : "";
  const reqSorting = sorting
    ? `&order_by=${sorting.value ? sorting.key : `-${sorting.key}`}`
    : "";
  const reqSearch = `&search=${searchString}`;

  return await http.get(
    `/csv-history-list?per_page=${limit}${reqPage}${reqSorting}${reqSearch}`
  );
}

export async function fetchAccountLettersHistory(
  page = 1,
  sorting,
  searchString = "",
  limit = 25
) {
  const reqPage = page ? `&page=${page}` : "";
  const reqSorting = sorting
    ? `&order_by=${sorting.value ? sorting.key : `-${sorting.key}`}`
    : "";
  const reqSearch = `&search=${searchString}`;

  return await http.get(
    `/letters-status-account?page_size=${limit}${reqPage}${reqSorting}${reqSearch}`
  );
}

export async function fetchContact(id) {
  return await http.get(`${prefix}-retrieve/${id}`);
}

export async function createContact(data) {
  return await http.post(`${prefix}-create`, data, { newErrorFormat: true });
}

export async function editContact(id, data) {
  return await http.patch(`${prefix}-update/${id}`, data);
}

export async function deleteContact(id) {
  return await http.del(`${prefix}-delete/${id}`);
}

export async function deleteContactsByTags(
  queryString,
  crossedDeletion = true
) {
  return await http.del(
    `${prefix}-delete/?tag-ids=${queryString}&fmd=${crossedDeletion}`
  );
}

export async function validateContact(contact) {
  return await http.post("contact-validation-service", { ...contact });
}

export async function uploadCsv(data) {
  const { tags, mappings, csv } = data;

  return await http.upload("csv-upload", {
    name: csv.name,
    tags,
    map: mappings,
    csv
  });
}

export async function fetchMailPieceStatus(id) {
  return await http.get(`mail-piece-status-contact?contact_id=${id}`);
}

export async function fetchLettersStatus(id) {
  return await http.get(`letters-status-contact/${id}`);
}

export async function sendFlatFileUploads(data) {
  return await http.post("csv-batch-dispatcher", data);
}

export async function resendMailpiece(id) {
  return await http.post(`mail-piece-resend/${id}`, {});
}

export async function resendLetter(id) {
  return await http.post(`/letters-resend/${id}`, {});
}

export async function fetchMailPieceThumbnail(
  id,
  size = "small",
  side = "front"
) {
  return await http.get(
    `mail-piece-thumbnails/${id}?size=${size}&side=${side}`,
    null,
    { responseType: "blob" }
  );
}

export async function processActivities(activities, getIcons = true) {
  return await Promise.all([
    ...activities.map(async item => {
      if (getIcons) {
        // get thumbnail
        const resp = await fetchMailPieceThumbnail(item.id);
        const urlCreator = window.URL || window.webkitURL;
        item.thumbnail = urlCreator.createObjectURL(resp);
      }

      if (!item.latest_status) {
        item.latestStatus = "created_at";
        item["created_at"] = item.created_at;
      } else {
        item.latestStatus = item.latest_status;
      }

      return item;
    })
  ]);
}
